(function($, window, undefined) {
	'use strict';

	/**
	 * [overlayMask description]
	 * @param  {[type]} selector [description]
	 * @param  {[type]} options  [description]
	 * @return {[type]}          [description]
	 */
	App.overlayMask = function(selector, options) {
		this.selector = selector;
		this.elementJquery = $(selector);
		this.css = $.extend({
			'background': 'rgba(0, 0, 0, 0.7)',
			'position': 'fixed',
			'top': 0,
			'left': 0,
			'width': '100%',
			'height': '100%',
			'display': 'none',
			'z-index': 2,
		}, options);
		this.overlayMaskHtml = null;
	};

	App.overlayMask.prototype.init = function() {
		this.overlayMaskHtml = $('<div/>', {
			'css': this.css,
			'class': 'overlay-mask'
		}).appendTo(this.selector);

		$(this.overlayMaskHtml).fadeIn(100);

		this.elementJquery.css('position', 'relative');
	};

	App.overlayMask.prototype.remove = function() {
		$(this.overlayMaskHtml).fadeOut(100, function() {
			$(this.overlayMaskHtml).remove();
		}.bind(this));
	};

	App.overlayMask.prototype.removeAll = function() {
		$('.overlay-mask').fadeOut(100, function() {
			$('.overlay-mask').remove();
		});
	};
})(jQuery, window);